import { DataBean } from "../DataBean";

export class ProductionOrderRemission extends DataBean {


    public async getProductionOrderRemissionCatalogByProductionOrder(idProductionOrder:any,productionOrderDate:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getProductionOrderRemissionCatalogByProductionOrder_Number_java.util.Date", [idProductionOrder,productionOrderDate]);
    }

  

}